// Dollar-formats a cents integer ("$7.33"), shared by every product-owner
// run-cost display. `null`/`undefined` (no recorded cost, or a rate/average
// whose denominator was zero) renders as an em dash rather than "$0.00" or
// "$NaN" — those are different facts from "cost genuinely zero".
export function formatCents(cents: number | null | undefined): string {
  if (cents == null) return '—'
  return `$${(cents / 100).toFixed(2)}`
}
